var map = {
	"./1.png": 31270,
	"./10.png": 22900,
	"./11.png": 44029,
	"./2.png": 72509,
	"./3.png": 51380,
	"./4.png": 97291,
	"./5.png": 76162,
	"./6.png": 24345,
	"./7.png": 27440,
	"./8.png": 77975,
	"./9.png": 34958,
	"./target1.png": 86423
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 52319;